import { ROOTSTOCKTESTNET } from '../types';
export default {
  type: ROOTSTOCKTESTNET,
  service: 'RSK Public Testnet Websocket',
  url: 'wss://nodes.mewapi.io/ws/rsktest',
  auth: null,
  username: '',
  password: ''
};
